import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const ScheduledCancellations = ({ qa }) => {
  const { displayScheduledCancellations, scheduledCancellationsNumber, url, tooltip } = useSelector(
    (state) => state.membershipUnits.membershipUnits.scheduledCancellations
  );

  return displayScheduledCancellations ? (
    <div className="content__el">
      <DataDisplay
        label="Scheduled Cancellations"
        type="number"
        value={scheduledCancellationsNumber}
        url={url}
        disableAnimation={qa}
        toolTipContent={tooltip}
        toolTipId="scheduledCancellationsNumber"
      />
    </div>
  ) : null;
};

export default ScheduledCancellations;
